<!-- 
アンケートの一覧画面
@props
  itemList : アンケートの配列
-->

<template>
  <div>
    <div class="ml-2 text-h5">アンケート</div>
    <v-data-table
      locale="jp"
      mobile-breakpoint="0"
      v-model="selected"
      :headers="headers"
      :items="itemList"
      item-key="recordId"
      show-select
      hide-default-footer
      :single-select="false"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      no-results-text="検索条件に合うデータがありません"
      no-data-text="データがありません"
    >
      <!-- 表ヘッダ部のボタン -->
      <template v-slot:top>
        <v-btn
          color="primary"
          class="ma-2"
          @click="create"
          :disabled="false"
        >
          新規登録
        </v-btn>

        <v-menu bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              class="ma-2"
              v-bind="attrs"
              v-on="on"
              :disabled="!selectionStatus.includes('contain.any')"
            >
              操作 <v-icon>mdi-chevron-down</v-icon></v-btn
            >
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
              :disabled="!selectionStatus.includes(item.condition)"
              @click="item.event"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <!-- ヘッダの定義 -->
      <template v-slot:[`header.data-table-select`]="{ props, on }">
        <v-simple-checkbox
          v-if="false"
          :value="props.value || props.indeterminate"
          v-on="on"
          :indeterminate="props.indeterminate"
          dark
          :ripple="false"
        />
      </template>
      <template
        v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
      >
        <v-simple-checkbox
          :value="isSelected"
          @input="select($event)"
          @click="selectedCheckbox(item)"
          :ripple="false"
        >
        </v-simple-checkbox>
      </template>
      <!-- テーブルのコンテンツの定義 -->
      <template v-slot:[`item.title`]="{ item }">
        <td class="fixed-width-300 text-truncate">{{ item.title }}</td>
      </template>
      <template v-slot:[`item.url`]="{ item }">
        <td class="fixed-width-300"><router-link :to="`/answer/${item.url}`">{{ item.url }}</router-link></td>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <td class="fixed-width-300">{{ item.createdAt }}</td>
      </template>
      <template v-slot:[`item.result`]="{ item }">
        <td>
        <v-chip
            color="primary"
            dark
            label
            @click.stop="resultView(item)"
        >
          表示
        </v-chip>
        </td>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="7"
      ></v-pagination>
    </div>
    <!-- 確認ダイアログ -->
    <confirm-dialog ref="confirm_question_delete" @on-click-ok="deleteQuestion">
      アンケートを削除します。よろしいですか？
    </confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from "../dialog/confirm.vue";
export default {
  props: ["itemList"],
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  computed: {
    /**
     * チェックボックスの選択状態
     */
    selectionStatus() {
      if (this.selectedQuestionList.length == 0) {
        return [];
      }
      return ["contain.any"];
    },
    /**
     * チェックボックスで選択したアカウントの一覧
     */
    selectedQuestionList() {
      return this.selected;
    },
  },
  data() {
    return {
      // 表示中のページ番号
      page: 1,
      // ページ数
      pageCount: 0,
      // ページあたりに表示するユーザー件数
      itemsPerPage: 20,
      // 選択中のユーザー情報
      selected: [],
      // 一覧のヘッダ定義
      headers: [
      {
          text: "タイトル",
          align: "start",
          value: "title",
          class: "grey darken-1 white--text",
          width: "300px",
        },
        {
          text: "URL",
          align: "start",
          value: "url",
          class: "grey darken-1 white--text",
          width: "300px",
        },
        {
          text: "作成日",
          align: "start",
          value: "createdAt",
          class: "grey darken-1 white--text",
          width: "300px",
        },
        {
          text: "結果表示",
          align: "start",
          value: "result",
          class: "grey darken-1 white--text",
          width: "300px",
        },
      ],
      // 操作ボタンを押した時に表示するメニューの一覧
      items: [
        {
          title: "編集",
          condition: "contain.any",
          event: () => {
            // アンケートを編集する
            this.editQuestion();
          },
        },
        {
          title: "削除",
          condition: "contain.any",
          event: () => {
            // アンケートを削除する
            this.$refs.confirm_question_delete.showDialog();
          },
        },
      ],
    };
  },
  methods: {
    /**
     * アンケートを編集する
     */
    editQuestion() {
      this.$router.push(`/question/edit/${this.selected[0].recordId}`);
    },
    /**
     * アンケートを作成する
     */
    create() {
      this.$router.push("/question/edit/create");
    },
    /**
     * アンケートを削除する
     */
    deleteQuestion() {
      this.$emit("on-delete", this.selectedQuestionList);
      this.selected = [];
    },
    selectedCheckbox(item) {
      if (this.selected.length >= 1) {
        if (this.selected[0].recordId != item.recordId){
          this.selected = [];
          this.selected[0] = item;
        } else {
          this.selected = [];
        }
      }
    },
    /**
     * アンケート結果を表示する
     */
    resultView(item) {
      this.$router.push(`/question/result/${item.recordId}`);
    },
  },
};
</script>

<style>
th {
  background-color: #757575 !important;
}
th.sortable .v-data-table-header__icon {
  color: rgb(255, 255, 255, 0.15) !important;
}
th.sortable.active .v-data-table-header__icon {
  color: rgb(255, 255, 255, 1) !important;
}
</style>
